import React from 'react'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {NoStyleButton} from '@vio/atlas/helpers/NoStyleButton'
import {Icon} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

import {Price} from '../../../search/Price/Price'
import {DealFreezeBannerCard} from '../common/DealFreezeBannerCard'
import {DEAL_FREEZE_OFFER_BOX_BANNER} from './constants'
import {dealFreezeOfferBoxMessages} from './messages'
import {FromPrice} from './types'

const FullWidthButton = styled(NoStyleButton)`
  display: block;
  width: 100%;
  text-align: start;
`

interface Props {
  onClick: () => void
  fromPrice?: FromPrice
  dataId?: string
}

export const DealFreezeOfferBoxBanner = ({
  onClick,
  fromPrice,
  dataId = DEAL_FREEZE_OFFER_BOX_BANNER
}: Props) => (
  <FullWidthButton type="button" onClick={onClick} data-id={dataId}>
    <DealFreezeBannerCard
      tagSize="xs"
      headingGap="s300"
      contentGap="s200"
      title={<FormattedMessageWrapper {...dealFreezeOfferBoxMessages.title} />}
      tagLabel={
        <FormattedMessageWrapper
          {...dealFreezeOfferBoxMessages.freezableDeals}
        />
      }
      endSlot={
        <Box display="flex" alignItems="center" gap="s200">
          {fromPrice && (
            <Box display="flex" flexDirection="column" alignItems="flex-end">
              <Text variant="bodyXS" colorPath="content.neutral.secondary">
                <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.from} />
              </Text>
              <Price
                value={fromPrice.value}
                currency={fromPrice.currency}
                size="sm"
                roundingStrategy="round"
                dataId={`${dataId}Price`}
              />
            </Box>
          )}
          <Icon
            name="ChevronRight"
            size="sm"
            colorPath="content.neutral.secondary"
          />
        </Box>
      }
    >
      <FormattedMessageWrapper {...dealFreezeOfferBoxMessages.description} />
    </DealFreezeBannerCard>
  </FullWidthButton>
)
